import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { IconHelp } from "@tabler/icons-react";
import { Menu, Navlink } from "@/shared/ui";
import { MaxMessengerBrandIcon } from "@/shared/ui/MaxMessengerBrandIcon/MaxMessengerBrandIcon";
import { openSupportBot } from "@/shared/lib/support/openSupportBot";
import { getMiniAppPlatform } from "@/shared/lib/miniApp";
import { translations } from "../constants";
const TelegramGlyph = FaTelegramPlane;
/**
 * Пункт сайдбара «Поддержка». По клику открывает мини-меню выбора мессенджера
 * (Telegram / MAX) и уводит юзера в соответствующий бот поддержки с
 * идентифицирующим deep-link (см. openSupportBot).
 *
 * Показываем только в веб-версии: внутри реального mini-app (Telegram/MAX)
 * уводить юзера в бота смысла нет — выходим по getMiniAppPlatform().
 */
export const SupportMenu = ({ language }) => {
    // Только веб: внутри mini-app-оболочки виджет не рендерим.
    if (getMiniAppPlatform() !== null) {
        return null;
    }
    const t = translations[language];
    return (_jsx(Menu, { position: "right-start", minWidth: 230, portal: true, trigger: _jsx(Navlink, { as: "button", icon: _jsx(IconHelp, { size: 18, stroke: 1.6 }), label: t.support }), items: [
            {
                id: "telegram",
                icon: _jsx(TelegramGlyph, { size: 16 }),
                label: language === "ru" ? "Написать нам в Telegram" : "Message us on Telegram",
                onClick: () => void openSupportBot("telegram"),
            },
            {
                id: "max",
                icon: _jsx(MaxMessengerBrandIcon, { size: 18 }),
                label: language === "ru" ? "Написать нам в MAX" : "Message us on MAX",
                onClick: () => void openSupportBot("max"),
            },
        ] }));
};
